import { BlockBlobClient } from '@azure/storage-blob';
import { UploadTokenAzureStorageSasResult } from '../api/models';
import { boundProgressType } from '../components/FileUpload';

const azureFileUpload = async (
	file: File,
	credentials: UploadTokenAzureStorageSasResult,
	progressCallback?: boundProgressType
) => {
	const { sasUri, fileName } = credentials;

	if (!sasUri || !fileName) return false;

	const blockBlobClient = new BlockBlobClient(sasUri);

	const options = {
		blobHTTPHeaders: { blobContentType: file.type },
		onProgress: (event: { loadedBytes: number }) => {
			if (progressCallback) {
				progressCallback(event.loadedBytes);
			}
		}
	};
	try {
		const response = await blockBlobClient.uploadData(file, options);
		blockBlobClient.setMetadata({
			OriginalFileName: encodeURI(file.name),
			ContentDisposition: 'attachment; filename=' + encodeURI(file.name)
		});

		return !!response;
	} catch (err) {
		console.log(err);
		return false;
	}
};

export default azureFileUpload;
